import React from 'react'
import PropTypes from 'prop-types'

function Arrow({ width, height, className, fill, title }) {
  return (
    <svg
      role="img"
      aria-labelledby={title}
      viewBox="0 0 32 20"
      width={width}
      height={height}
      className={className}
    >
      <title id={title}>{title}</title>
      <path
        d="M30 2L16 16 2 2"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={4}
        fill="none"
      />
    </svg>
  )
}

Arrow.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  className: PropTypes.string.isRequired,
  fill: PropTypes.string,
  title: PropTypes.string.isRequired
}

Arrow.defaultProps = {
  fill: 'none'
}

export default Arrow
